import vehicleImages from './vehicleImages/vehicleImagesSlice';

const root = {
	vehicleImages
};

export default root;
